/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener("click", function (e) {
  const a = e.target.closest('a[href="#size-guide"]');
  if (!a) return;

  e.preventDefault();

  // Click the existing Palo Alto size guide trigger
  const btn = document.querySelector(
    'button[data-drawer-toggle][aria-controls^="popup-text--"]'
  );
  if (btn) btn.click();
});


  (function () {
    function getLiveCartDrawer() {
      return document.querySelector('[data-cart-drawer]');
    }

    function getSummerSetMessageEl() {
      const drawer = getLiveCartDrawer();
      if (!drawer) return null;
      return drawer.querySelector('[data-summer-set-message]');
    }

    function getLiveSummerSetItems() {
      const drawer = getLiveCartDrawer();
      if (!drawer) return [];
      return drawer.querySelectorAll('[data-cart-item][data-summer-set-item="true"]');
    }

    function getSummerSetCount() {
      const items = getLiveSummerSetItems();
      let count = 0;

      items.forEach(function (item) {
        const qty = parseInt(item.getAttribute('data-summer-set-qty') || '1', 10);
        count += isNaN(qty) ? 1 : qty;
      });

      return count;
    }

    function getSummerSetContent(count) {
      if (count === 1) {
        return {
          hidden: false,
          success: false,
          heading: 'Complete Your Summer Set 🔥',
          text: 'You’re 1 item away from 15% off.',
          subtext: 'Mix & match shorts, tees and linen.'
        };
      }

      if (count === 2) {
        return {
          hidden: false,
          success: true,
          heading: '15% unlocked 🎉',
          text: 'Add 1 more item to save 20%.',
          subtext: 'Discount applied at checkout.'
        };
      }

      if (count >= 3) {
        return {
          hidden: false,
          success: true,
          heading: '20% unlocked 🎉',
          text: 'Your summer set discount is ready.',
          subtext: 'Discount applied at checkout.'
        };
      }

      return {
        hidden: true,
        success: false,
        heading: '',
        text: '',
        subtext: ''
      };
    }

    function updateSummerSetMessage() {
      const message = getSummerSetMessageEl();
      if (!message) return;

      const headingEl = message.querySelector('[data-summer-set-heading]');
      const textEl = message.querySelector('[data-summer-set-text]');
      const subtextEl = message.querySelector('[data-summer-set-subtext]');

      const count = getSummerSetCount();
      const content = getSummerSetContent(count);

      message.dataset.summerSetCount = String(count);
      message.classList.toggle('is-hidden', content.hidden);
      message.classList.toggle('is-success', content.success);

      if (headingEl) headingEl.textContent = content.heading;
      if (textEl) textEl.textContent = content.text;
      if (subtextEl) subtextEl.textContent = content.subtext;
    }

    function runSummerSetUpdateWithDelay(delay) {
      window.setTimeout(updateSummerSetMessage, delay || 300);
    }

    function bindSummerSetEvents() {
      const drawer = getLiveCartDrawer();
      if (!drawer) return;

      const observer = new MutationObserver(function () {
        runSummerSetUpdateWithDelay(50);
      });

      observer.observe(drawer, {
        childList: true,
        subtree: true
      });

      document.addEventListener('click', function (event) {
        const addBtn = event.target.closest('[data-add-to-cart], [name="add"], [data-upsell-btn]');
        const qtyBtn = event.target.closest('[data-quantity-plus], [data-quantity-minus], [data-item-remove]');
        const cartToggle = event.target.closest('[data-cart-drawer-toggle]');

        if (addBtn || qtyBtn || cartToggle) {
          runSummerSetUpdateWithDelay(500);
        }
      });

      document.addEventListener('change', function (event) {
        const qtyInput = event.target.closest('[data-quantity-field], input[name="updates[]"]');
        if (qtyInput) {
          runSummerSetUpdateWithDelay(500);
        }
      });

      document.addEventListener('DOMContentLoaded', function () {
        runSummerSetUpdateWithDelay(100);
      });

      window.setTimeout(function () {
        runSummerSetUpdateWithDelay(300);
      }, 300);

      window.setTimeout(function () {
        runSummerSetUpdateWithDelay(800);
      }, 800);

      document.addEventListener('cart:updated', function () {
        runSummerSetUpdateWithDelay(200);
      });

      document.addEventListener('cart:refresh', function () {
        runSummerSetUpdateWithDelay(200);
      });

      document.addEventListener('theme:cart:updated', function () {
        runSummerSetUpdateWithDelay(200);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindSummerSetEvents);
    } else {
      bindSummerSetEvents();
    }
  })();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

